import style from "./frameVisiblePicker.module.css";
import ToggleButton from "./toggle-button";
import { Icon } from "../toolbar-buttons";

export default function VisiblePicker({ value, onChange }: { value?: boolean; onChange: (visible: boolean) => void }) {
  value = value ?? true;

  return (
    <>
      <div className={style.container} data-testid="FrameVisible">
        <ToggleButton
          tooltip={value ? "Hide Frame" : "Show Frame"}
          isOn={true}
          onClick={() => {
            onChange(!value);
          }}
          className={style.button}
        >
          {value ? <Icon icon="icon-eye-open" /> : <Icon icon="icon-eye-closed" />}
        </ToggleButton>
      </div>
    </>
  );
}
